import { format, getUnitOfMeasurement } from '@monofront/business/utils';
import { useProduct } from '../ProductCard';
import { useFormatProductWeight } from '@monofront/business/hooks/product/useFormatProductWeight';
import { useProductPricing } from '@monofront/business/hooks/product/useProductPricing';
import { FC } from 'react';

type ProductFormatAndUnitPriceProps = {
  quantity?: number;
};

export const ProductFormatAndUnitPrice: FC<ProductFormatAndUnitPriceProps> = ({
  quantity = 1,
}) => {
  const product = useProduct();
  const { formatProductWeight } = useFormatProductWeight();
  const formattedWeight = formatProductWeight(product?.meta.finance, true);

  if (!product) {
    return (
      <div
        data-testid="product-title"
        className="tw-m-2 tw-h-6 tw-w-10/12 tw-animate-pulse tw-rounded-md tw-bg-black-200 tw-grid-area-[format]"
      ></div>
    );
  }

  const unitOfMeasurement = getUnitOfMeasurement(product);
  const productPricing = useProductPricing(product, quantity);

  if (!productPricing.unitPrice || !unitOfMeasurement) return null;

  return (
    <p
      data-testid="product-weight-formatted-unit-price"
      className="tw-flex tw-items-center tw-text-sm tw-text-black-700 tw-grid-area-[format]"
    >
      {formattedWeight && (
        <>
          <b>{formattedWeight}</b>
          <span className="tw-mx-2 tw-block tw-h-[14px] tw-w-px tw-bg-blue-200"></span>
        </>
      )}
      {format(productPricing.unitPrice)}/{unitOfMeasurement}
    </p>
  );
};
